import Vue from 'vue';
import Vuex from 'vuex';
import i18n from './i18n';
import hours from './hours';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    i18n,
    hours
  },
  state: {
    storeLimit: null,
    storeOccupancy: null,
    key: null,
    user: undefined,
    storeId: null,
    interval: process.env.VUE_APP_ENDPOINT_DEFAULT_REFRESH_INTERVAL,
    forecasts: [],
    storeName: 'Our Store',
  },

  mutations: {
    clear(state) {
      state.storeLimit = null;
      state.storeOccupancy = null;
      state.storeId = null;
      state.interval = process.env.VUE_APP_ENDPOINT_DEFAULT_REFRESH_INTERVAL;
    },
    clearForecasts(state) {
      state.forecasts = [];
    },
    setForecasts(state, data) {
      state.forecasts = data;
    },
    setStoreLimit(state, data) {
      // set store limit
      state.storeLimit = data.find(l => l.end_time === null) || null;
    },
    setStoreOccupancy(state, data) {
      // set store occupancy
      state.storeOccupancy = data;
    },
    setKey(state, key) {
      state.key = key;
    },
    setUser(state, data) {
      state.user = data;
    },
    selectSite(state, id) {
      state.storeId = id;
    },
    setInterval(state, interval) {
      state.interval = interval;
    },
    setName(state, name) {
      state.storeName = name;
    }
  },

  actions: {
    KEY_CHECK({commit}) {
      let cookie = (process.env.VUE_APP_COOKIE_NAME) ? process.env.VUE_APP_COOKIE_NAME : 'bearer';
      if (localStorage.getItem(cookie)) {
        commit('setKey', localStorage.getItem(cookie));
      }
    },

    SET_USER({commit}, data) {
      localStorage.setItem(process.env.VUE_APP_COOKIE_NAME, data.api_key);
      commit('setUser', data);
      commit('setKey', data.api_key);
    },

    SELECT_SITE({commit}, id) {
      return new Promise((resolve) => {
        commit('selectSite', id);
        setTimeout(() => {
          resolve();
        },100);
      });
    },
    CLEAR({commit}) {
      commit('clear');
    },

    CLEAR_FORECASTS({commit}) {
      commit('clearForecasts');
    },

    SET_FORECASTS({commit}, data) {
      commit('setForecasts',data);
    },

    SET_STORE_NAME({commit}, name) {
      localStorage.setItem('storeName', name);
      commit('setName', name);
    },
    STORE_NAME_CHECK({commit}) {
      if (localStorage.getItem('storeName')) {
        commit('setName', localStorage.getItem('storeName'));
      }
    }
  },

  getters: {
    key: state => {
      return state.key;
    },

    storeLimit: state => {
      return state.storeLimit;
    },
    storeOccupancy: state => {
      // get store occupancy
      return state.storeOccupancy;
    },
    currentStore: state => {
      return state.storeId;
    },
    interval: state => {
      return state.interval;
    },
    forecasts: state => {
      return state.forecasts;
    },
    storeName: state => {
      return state.storeName;
    }
  }
});
